import L from 'leaflet';

const AvatarOverlay = L.ImageOverlay.extend({
    _initImage() {
        const wasElementSupplied = this._url.tagName === 'DIV';
        const div = this._image = wasElementSupplied ? this._url : document.createElement('div');

        div.classList.add('leaflet-image-layer');
        if (this._zoomAnimated) { div.classList.add('leaflet-zoom-animated'); }
        if (this.options.className) { div.classList.add(this.options.className); }

        div.onselectstart = () => false;
        div.onmousemove = () => false;

        div.innerHTML = this._url; // Assuming _url is the HTML content
    }
});

L.AvatarOverlay = function (innerHTML, bounds, options) {
    return new AvatarOverlay(innerHTML, bounds, options);
};

export default L.AvatarOverlay; // Ensure you are exporting the factory function



